const messages = {
  threads: {
    orders: { title: "", content: "" },
    externalTraining: { title: "", content: "" },
    InvestmentSupport: { title: "", content: "" },
    onlineTraining: { title: "", content: "" },
    bTraining: { title: "", content: "" },
    hunter: { title: "", content: "" },
    profileComplete: { title: "", content: "" },
    activeUser: { title: "", content: "" },
    deleteItemFromOrder: { title: "", content: "" },
    deleteOrder: { title: "", content: "" },
    commitmentLetter: {
      title: "Täname registreerimise eest",
      content:
        "Lugupeetud,<br/>Täname registreerimise eest. Meil on hea meel teatada, et Teie registreerimine BRIDGESTONE PLUS-is on üle vaadatud ja heaks kiidetud.<br/>Loodame, et BRIDGESTONE PLUS toob Teile edu ning väärtuslikke võimalusi. Soovime meeldivat koostöö jätkumist.<br/>Parimate soovidega,<br/>BRIDGESTONE PLUS meeskond",
    },
    uberall: { title: "", content: "" },
    welcome: {
      title: "Täname registreerimise eest",
      content:
        "Lugupeetud,<br/>Täname registreerimise eest. Meil on hea meel teatada, et Teie registreerimine BRIDGESTONE PLUS-is on üle vaadatud ja heaks kiidetud.<br/>Loodame, et BRIDGESTONE PLUS toob Teile edu ning väärtuslikke võimalusi. Soovime meeldivat koostöö jätkumist.<br/>Parimate soovidega,<br/>BRIDGESTONE PLUS meeskond",
    },
    booster: { title: "", content: "" },
    orderStatus_RETURNED: { title: "", content: "" },
    orderStatus_REJECTED: { title: "", content: "" },
    kickbackPayback: { title: "", content: "" },
    survey_thankyou: { title: "", content: "" },
    survey: { title: "", content: "" },
    salesPromotions: { title: "", content: "" },
  },
};

export default {
  messages,
};
